import NotFound from './NotFoundContainer';

export default NotFound;
